<template>
  <v-container fluid class="pa-0">
    <div class="pa-8 d-flex align-center">
      <div>
        <div class="d-flex align-center mb-1">
          <v-icon color="blue" class="mr-2">mdi-truck-delivery-outline</v-icon>
          <h1 class="text-h4 font-weight-black white--text">
            Listas de Compra
          </h1>
        </div>
        <p class="grey--text mb-0">
          Monitoreo de costos de proveedores y comparación de tarifas de
          entrada.
        </p>
      </div>
      <v-spacer></v-spacer>

      <v-fade-transition>
        <div v-if="seleccionados.length > 1">
          <v-btn
            color="blue"
            x-large
            rounded
            class="px-8 shadow-plus"
            @click="comparar"
          >
            <v-icon left>mdi-swap-horizontal</v-icon>
            Comparar {{ seleccionados.length }} proveedores
          </v-btn>
        </div>
      </v-fade-transition>
    </div>

    <div class="px-8">
      <div
        v-for="p in proveedoresComputed"
        :key="p.id"
        class="item-row d-flex align-center pa-4 mb-2 rounded-lg"
        :class="{ 'item-selected': seleccionados.includes(p.id) }"
      >
        <div class="mr-4">
          <v-checkbox
            v-model="seleccionados"
            :value="p.id"
            hide-details
            dark
            color="blue"
          ></v-checkbox>
        </div>

        <v-avatar size="50" color="#222" class="mr-4 border-subtle">
          <span class="blue--text font-weight-bold">{{
            p.nombre.charAt(0)
          }}</span>
        </v-avatar>

        <div style="min-width: 250px">
          <div class="white--text font-weight-bold text-h6">{{ p.nombre }}</div>
          <div class="d-flex align-center mt-1">
            <v-icon
              x-small
              :color="isOld(p.last_update) ? 'orange' : 'green'"
              class="mr-1"
              >mdi-circle</v-icon
            >
            <span class="text-caption grey--text">{{
              isOld(p.last_update) ? "Toca actualizar" : "Al día"
            }}</span>
          </div>
        </div>

        <v-spacer></v-spacer>

        <div class="text-right mr-10">
          <div class="grey--text text-overline">Última carga</div>
          <div class="white--text font-weight-medium">
            {{ p.last_update ? moment(p.last_update).format("LL") : "---" }}
          </div>
        </div>

        <div class="d-flex actions-hover">
          <v-btn
            icon
            color="grey lighten-1"
            class="mx-1"
            :to="{
              name: 'empresa.proveedor.listadeprecios',
              params: { id_proveedor: p.id },
            }"
          >
            <v-icon>mdi-upload-outline</v-icon>
          </v-btn>
          <v-btn
            icon
            color="grey lighten-1"
            class="mx-1"
            :to="{
              name: 'empresa.proveedor.profile',
              params: { id_proveedor: p.id },
            }"
          >
            <v-icon>mdi-open-in-new</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div v-if="loading" class="text-center py-10">
      <v-progress-circular indeterminate color="blue"></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
import ProveedoresAPI from "@/api/proveedores/proveedor";

export default {
  props: ["search", "baseRoute"],
  data: () => ({
    proveedores: [],
    seleccionados: [],
    loading: false,
  }),
  computed: {
    proveedoresComputed() {
      if (!this.search) return this.proveedores;
      return this.proveedores.filter((p) =>
        p.nombre.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    async fetchListas() {
      this.loading = true;
      try {
        const response = await ProveedoresAPI.conListaDePrecios();
        // IMPORTANTE: Asignamos los datos que vienen del servidor
        this.proveedores = response.data;
      } catch (e) {
        console.error("Error cargando proveedores", e);
      } finally {
        this.loading = false;
      }
    },
    /**
     * Determina si una lista de precios está obsoleta.
     * * @param {String|Date} date - Fecha de la última actualización de la lista.
     * @returns {Boolean} - Devuelve true si la lista tiene más de 30 días o no existe.
     */
    isOld(date) {
      // Si no hay fecha registrada, asumimos que es vieja (o inexistente) para forzar actualización.
      if (!date) return true;

      // Calculamos la diferencia en milisegundos entre hoy y la fecha de la lista.
      // Luego convertimos esos milisegundos a días: (1000ms * 60s * 60min * 24h).
      const diff = (new Date() - new Date(date)) / (1000 * 60 * 60 * 24);

      // Retornamos true si la antigüedad supera el umbral de 30 días.
      return diff > 30;
    },
    comparar() {
      this.$router.push({
        name: "empresa.proveedores.comparativa",
        query: { ids: this.seleccionados.join(",") },
      });
    },
    subirArchivo(p) {
      console.log("Subiendo archivo para:", p.nombre);
    },
  },
  mounted() {
    this.fetchListas();
  },
};
</script>

<style scoped>
.item-row {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid transparent;
  transition: all 0.2s;
}
.item-row:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: #444;
}
.item-selected {
  background: rgba(33, 150, 243, 0.08) !important;
  border-color: #2196f3 !important;
}
.border-subtle {
  border: 1px solid #333;
}
.shadow-plus {
  box-shadow: 0 10px 30px rgba(33, 150, 243, 0.3) !important;
}
.actions-hover {
  opacity: 0.6;
}
.item-row:hover .actions-hover {
  opacity: 1;
}
</style>